var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDownline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35580",
    "data-name": "Group 35580",
    transform: "translate(4180 -943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35555",
    "data-name": "Group 35555",
    transform: "translate(-4180 943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19332",
    "data-name": "Path 19332",
    d: "M77,0A77,77,0,1,1,0,77,77,77,0,0,1,77,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18588_-_Outline",
    "data-name": "Path 18588 - Outline",
    d: "M76.944,6.318A70.627,70.627,0,0,0,27,126.885,70.627,70.627,0,1,0,126.885,27,70.164,70.164,0,0,0,76.944,6.318m0-6.318A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(0 0.112)",
    fill: "#ffd055"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35571",
    "data-name": "Group 35571",
    transform: "translate(33.426 38.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35564",
    "data-name": "Group 35564",
    transform: "translate(0 31.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35563",
    "data-name": "Group 35563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35582",
    "data-name": "Path 35582",
    d: "M73.971,236.192H65.488a12.665,12.665,0,0,0-3.336.448,12.706,12.706,0,0,0-11.32-6.96h-15a12.706,12.706,0,0,0-11.32,6.96,12.665,12.665,0,0,0-3.336-.448H12.7A12.71,12.71,0,0,0,0,248.887v13.562a7.626,7.626,0,0,0,7.617,7.617H79.049a7.626,7.626,0,0,0,7.617-7.617V248.887A12.71,12.71,0,0,0,73.971,236.192ZM23.14,242.376v22.613H7.617a2.542,2.542,0,0,1-2.539-2.539V248.888A7.626,7.626,0,0,1,12.7,241.27h8.484a7.588,7.588,0,0,1,1.992.266C23.153,241.814,23.14,242.094,23.14,242.376Zm35.308,22.613H28.218V242.376a7.626,7.626,0,0,1,7.617-7.617h15a7.626,7.626,0,0,1,7.617,7.617Zm23.14-2.539a2.542,2.542,0,0,1-2.539,2.539H63.526V242.376c0-.282-.013-.562-.031-.839a7.6,7.6,0,0,1,1.992-.266h8.484a7.626,7.626,0,0,1,7.617,7.617Z",
    transform: "translate(0.241 -229.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35582_-_Outline",
    "data-name": "Path 35582 - Outline",
    d: "M36.026,229.63h15a12.89,12.89,0,0,1,11.445,6.919,12.925,12.925,0,0,1,3.211-.406h8.483A12.951,12.951,0,0,1,87.1,249.078V262.64A7.867,7.867,0,0,1,79.24,270.5H7.808A7.867,7.867,0,0,1-.05,262.64V249.078a12.951,12.951,0,0,1,12.936-12.936h8.483a12.924,12.924,0,0,1,3.211.406A12.89,12.89,0,0,1,36.026,229.63Zm26.19,7.484-.089-.175a12.413,12.413,0,0,0-11.106-6.828h-15A12.413,12.413,0,0,0,24.92,236.94l-.089.175-.189-.052a12.449,12.449,0,0,0-3.273-.439H12.886A12.469,12.469,0,0,0,.431,249.078V262.64a7.385,7.385,0,0,0,7.377,7.376H79.24a7.385,7.385,0,0,0,7.377-7.376V249.078a12.469,12.469,0,0,0-12.455-12.455H65.678a12.449,12.449,0,0,0-3.273.439Zm-26.19-2.406h15a7.867,7.867,0,0,1,7.858,7.858V265.42H28.168V242.566A7.867,7.867,0,0,1,36.026,234.708ZM58.4,264.938V242.566a7.385,7.385,0,0,0-7.377-7.377h-15a7.385,7.385,0,0,0-7.377,7.377v22.372Zm7.28-23.718h8.483a7.867,7.867,0,0,1,7.858,7.858V262.64a2.783,2.783,0,0,1-2.78,2.78H63.476V242.566c0-.248-.01-.51-.03-.823l-.013-.2.19-.052A7.858,7.858,0,0,1,65.678,241.22ZM79.24,264.938a2.3,2.3,0,0,0,2.3-2.3V249.078a7.385,7.385,0,0,0-7.377-7.377H65.678a7.371,7.371,0,0,0-1.74.209c.013.24.019.452.019.656v22.372ZM12.886,241.22h8.483a7.84,7.84,0,0,1,2.055.275l.19.052-.013.2c-.021.314-.03.575-.03.823V265.42H7.808a2.783,2.783,0,0,1-2.78-2.78V249.078A7.867,7.867,0,0,1,12.886,241.22Zm10.223.69a7.356,7.356,0,0,0-1.74-.209H12.886a7.385,7.385,0,0,0-7.377,7.377V262.64a2.3,2.3,0,0,0,2.3,2.3H23.09V242.566C23.09,242.363,23.1,242.151,23.109,241.911Z",
    transform: "translate(0.05 -229.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35566",
    "data-name": "Group 35566",
    transform: "translate(5.656 14.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35565",
    "data-name": "Group 35565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35583",
    "data-name": "Path 35583",
    d: "M44.7,126.5a11.281,11.281,0,1,0,11.281,11.281A11.294,11.294,0,0,0,44.7,126.5Zm0,17.484a6.2,6.2,0,1,1,6.2-6.2A6.21,6.21,0,0,1,44.7,143.988Z",
    transform: "translate(-33.173 -126.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35583_-_Outline",
    "data-name": "Path 35583 - Outline",
    d: "M44.886,126.454a11.517,11.517,0,1,1-11.522,11.522A11.535,11.535,0,0,1,44.886,126.454Zm0,22.562a11.053,11.053,0,1,0-7.8-3.237A11.053,11.053,0,0,0,44.886,149.016Zm0-17.484a6.444,6.444,0,1,1-6.444,6.444A6.451,6.451,0,0,1,44.886,131.532Zm0,12.406a5.962,5.962,0,1,0-5.962-5.963A5.969,5.969,0,0,0,44.886,143.938Z",
    transform: "translate(-33.364 -126.454)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35568",
    "data-name": "Group 35568",
    transform: "translate(28.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35567",
    "data-name": "Group 35567",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35584",
    "data-name": "Path 35584",
    d: "M182.034,43.729A15.072,15.072,0,1,0,197.1,58.8,15.089,15.089,0,0,0,182.034,43.729Zm0,25.065a9.993,9.993,0,1,1,9.993-9.993A10,10,0,0,1,182.034,68.794Z",
    transform: "translate(-166.721 -43.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35584_-_Outline",
    "data-name": "Path 35584 - Outline",
    d: "M182.224,43.679a15.312,15.312,0,1,1-15.312,15.312A15.329,15.329,0,0,1,182.224,43.679Zm0,30.143a14.831,14.831,0,1,0-14.831-14.831A14.848,14.848,0,0,0,182.224,73.822Zm0-25.065A10.234,10.234,0,1,1,171.99,58.991,10.246,10.246,0,0,1,182.224,48.757Zm0,19.987a9.753,9.753,0,1,0-9.753-9.753A9.764,9.764,0,0,0,182.224,68.744Z",
    transform: "translate(-166.912 -43.679)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35570",
    "data-name": "Group 35570",
    transform: "translate(58.448 14.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35569",
    "data-name": "Group 35569",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35585",
    "data-name": "Path 35585",
    d: "M356.575,126.5a11.281,11.281,0,1,0,11.281,11.281A11.294,11.294,0,0,0,356.575,126.5Zm0,17.484a6.2,6.2,0,1,1,6.2-6.2A6.21,6.21,0,0,1,356.575,143.988Z",
    transform: "translate(-345.053 -126.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35585_-_Outline",
    "data-name": "Path 35585 - Outline",
    d: "M356.766,126.454a11.522,11.522,0,1,1-11.522,11.522A11.535,11.535,0,0,1,356.766,126.454Zm0,22.562a11.041,11.041,0,1,0-11.041-11.041A11.053,11.053,0,0,0,356.766,149.016Zm0-17.484a6.444,6.444,0,1,1-6.444,6.444A6.451,6.451,0,0,1,356.766,131.532Zm0,12.406a5.962,5.962,0,1,0-5.963-5.963A5.969,5.969,0,0,0,356.766,143.938Z",
    transform: "translate(-345.244 -126.454)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDownline);
export default __webpack_public_path__ + "static/media/add-downline.aff1f2c23f4cf36eb565d97960716a05.svg";
export { ForwardRef as ReactComponent };